import React, { useState } from 'react'
import _ from 'lodash'
import {
  Switch,
  FormControl,
  Input,
  Select,
  Button,
  Tr,
  Td,
} from '@chakra-ui/react'

export default function OperationAddingComponent({
  gaugeVariables,
  rendered,
  setRendered,
  operationList,
  setOperationList,
}) {
  const [selectedOperation, setSelectedOperation] = useState('')
  const [leftVariable, setLeftVariable] = useState('')
  const [rightVariable, setRightVariable] = useState('')

  const gaugeVariableList = () =>
    _.map(gaugeVariables, (variable) => (
      <div>
        <option value={variable.variableName}> {variable.variableName} </option>
      </div>
    ))

  const gaugeOperation = () => (
    <div>
      <option value="ADD"> บวก</option>
      <option value="SUBTRACT"> ลบ</option>
      <option value="MULTIPLY"> คูณ</option>
      <option value="DIVIDE"> หาร</option>
      <option value="NOP"> สิ้นสุดสมการ</option>
    </div>
  )

  const handlingAddOperation = () => {
    const tempOperationComponent = {
      leftVariable: _.size(operationList) === 0 ? leftVariable : null,
      rightVariable: rightVariable,
      operation: selectedOperation,
    }
    let tempOperationList = operationList
    tempOperationList.push(tempOperationComponent)
    setOperationList(tempOperationList)
    console.log(operationList)
    setRendered(!rendered)
  }

  return (
    <Tr>
      <Td></Td>
      <Td>
        {_.size(operationList) === 0 ? (
          <div>
            <Select
              className="w-1/3"
              size="sm"
              onChange={(event) => {
                setLeftVariable(event.target.value)
              }}
            >
              <option value="">ตัวแปร</option>
              {gaugeVariableList()}
            </Select>
          </div>
        ) : (
          <div>
            <label>ผลจากส่วนที่ {_.size(operationList) + 1} </label>
          </div>
        )}
      </Td>
      <Td>
        <Select
          className="w-1/3"
          size="sm"
          onChange={(event) => setSelectedOperation(event.target.value)}
        >
          <option value="">เลือกตัวดำเนินการ</option>
          {gaugeOperation()}
        </Select>
      </Td>
      <Td>
        <Select
          className="w-1/3"
          size="sm"
          onChange={(event) => {
            setRightVariable(event.target.value)
          }}
        >
          <option value="">เลือกตัวแปร</option>
          {gaugeVariableList()}
        </Select>
      </Td>
      <Td>
        <Button
          colorScheme="blue"
          size="sm"
          className="self-center"
          type="button"
          onClick={() => handlingAddOperation()}
        >
          เพิ่ม
        </Button>
      </Td>
    </Tr>
  )
}
